import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/gestion/entreprise/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/gestion/entreprise/$id/users', params, replace: true });
  },
});
